import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NoAuthLayout, { StyledSubmissionInput, StyledSubmissionField } from '@Components/Layout/NoAuth';
import { useAppTheme } from '@Components/Context';
import { AppButton } from '@Components/Control';
import { createInvitedUserRequest } from '@Actions';
import { paths } from '@Components/configs';

const InvitedUserContent = ({
  small,
  createInvitedUser,
  inviteToken,
}) => {
  const { theme } = useAppTheme();
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    /* eslint-disable camelcase */
    const requestBody = {
      user: {
        first_name: firstName,
        last_name: lastName,
        email,
        password,
        token: inviteToken,
      },
    };
    /* eslint-enable camelcase */
    createInvitedUser(requestBody, paths.login);
  };

  const submitDisabled = !firstName || !lastName || !email || !password
    || !confirmPassword || password !== confirmPassword;

  return (
    <NoAuthLayout
      seoConfig={null}
      title="Create account"
      small={small}
    >
      <StyledSubmissionField required name="firstName" htmlFor="firstName" type="text">
        <StyledSubmissionInput
          plain
          name="firstName"
          type="text"
          placeholder="First name"
          onChange={(e) => setFirstName(e.target.value)}
          value={firstName}
        />
      </StyledSubmissionField>
      <StyledSubmissionField required name="lastName" htmlFor="lastName" type="text">
        <StyledSubmissionInput
          plain
          name="lastName"
          type="text"
          placeholder="Last name"
          onChange={(e) => setLastName(e.target.value)}
          value={lastName}
        />
      </StyledSubmissionField>
      <StyledSubmissionField required name="email" htmlFor="email" type="email">
        <StyledSubmissionInput
          plain
          name="email"
          type="email"
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />
      </StyledSubmissionField>
      <StyledSubmissionField required name="password" htmlFor="password" type="password">
        <StyledSubmissionInput
          plain
          name="password"
          type="password"
          placeholder="Create a password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
        />
      </StyledSubmissionField>
      <StyledSubmissionField required name="confirmPassword" htmlFor="password" type="password">
        <StyledSubmissionInput
          plain
          name="confirmPassword"
          type="password"
          placeholder="Confirm password"
          onChange={(e) => setConfirmPassword(e.target.value)}
          value={confirmPassword}
        />
      </StyledSubmissionField>
      <AppButton
        overrideHover
        level="authSubmit"
        onClick={handleSubmit}
        disabled={submitDisabled}
        bgColor={theme.button.primaryBg}
        color={theme.button.primaryText}
        label="Submit"
        fontWeight={600}
        alignSelf="center"
      />
    </NoAuthLayout>
  );
};

InvitedUserContent.propTypes = {
  small: PropTypes.bool.isRequired,
  inviteToken: PropTypes.string.isRequired,
  createInvitedUser: PropTypes.func.isRequired,
};

const InvitedPage = ({
  small, createInvitedUser,
}) => {
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('token');

  if (inviteToken) {
    return (
      <InvitedUserContent
        small={small}
        inviteToken={inviteToken}
        createInvitedUser={createInvitedUser}
      />
    );
  }

  return <Navigate to={paths.root} />;
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createInvitedUser: createInvitedUserRequest,
  }, dispatch);
}

InvitedPage.propTypes = {
  small: PropTypes.bool.isRequired,
  createInvitedUser: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(InvitedPage);
